import type { CSSProperties } from 'react';
import type { Accent } from './contract';

const accentHex: Record<
  Accent,
  { base: string; strong: string; soft: string; ring: string; onAccent: string }
> = {
  green: { base: '#0a9d57', strong: '#087a44', soft: '#e6f6ee', ring: 'rgba(10, 157, 87, 0.32)', onAccent: '#ffffff' },
  blue: { base: '#1e5bff', strong: '#1648d6', soft: '#eaf0ff', ring: 'rgba(30, 91, 255, 0.32)', onAccent: '#ffffff' },
  violet: { base: '#7c3aed', strong: '#6d28d9', soft: '#f1ebff', ring: 'rgba(124, 58, 237, 0.32)', onAccent: '#ffffff' },
  orange: { base: '#ea580c', strong: '#c2410c', soft: '#fff0e6', ring: 'rgba(234, 88, 12, 0.32)', onAccent: '#ffffff' },
};

export function accentVars(accent: Accent): CSSProperties {
  const palette = accentHex[accent];
  return {
    ['--vp-accent-light' as string]: palette.base,
    ['--vp-accent-strong-light' as string]: palette.strong,
    ['--vp-accent-soft-light' as string]: palette.soft,
    ['--vp-accent-ring-light' as string]: palette.ring,
    ['--vp-on-accent-light' as string]: palette.onAccent,
  };
}
